import React from 'react';
import { pickLocalized } from '../../utils/testUtils';
import { ABILITY_REPORT_I18N_KEYS } from '../../utils/abilityVectorDisplay';
import AbilityScoreTile from '../widgets/AbilityScoreTile';
import AlgorithmResultsDisclaimer from './AlgorithmResultsDisclaimer';
import { testBtnPrimary } from './testUiClasses';

function AbilityChapterComplete({
  t,
  lang,
  chapter,
  chapterResult,
  timerExpired,
  hasNextChapter,
  onContinue
}) {
  const chapterTitle = chapter ? pickLocalized(chapter.title, lang) : '';
  const slug = chapterResult?.chapterSlug;
  const dimensionScore = chapterResult?.dimensionScore;

  return (
    <div className="bg-surface rounded-2xl shadow-sm p-6 md:p-8 text-center max-w-lg mx-auto">
      <h2 className="text-2xl font-bold text-ink mb-2 font-montserrat">
        {t('test.chapterComplete')}
      </h2>
      {chapterTitle ? (
        <p className="text-ink-muted mb-6">
          {t('test.thankYouChapter', { chapter: chapterTitle })}
        </p>
      ) : (
        <p className="text-ink-muted mb-6">{t('test.thankYou')}</p>
      )}
      {timerExpired ? (
        <p className="text-amber-700 mb-4 text-sm">{t('test.timeUpMessage')}</p>
      ) : null}

      {slug && dimensionScore != null ? (
        <div className="mb-6 text-left">
          <h3 className="text-sm font-semibold uppercase tracking-wide text-ink-subtle mb-3 text-center">
            {t('test.chapterPreliminaryHeading')}
          </h3>
          <AbilityScoreTile
            slug={slug}
            value={dimensionScore}
            label={t(ABILITY_REPORT_I18N_KEYS[slug] || 'test.chapterScore')}
          />
          <p className="mt-3 text-xs text-ink-subtle text-center">
            {t('test.chapterPreliminaryHint')}
          </p>
        </div>
      ) : (
        <p className="mb-6 text-sm text-ink-subtle">{t('test.chapterPreliminarySignIn')}</p>
      )}

      <AlgorithmResultsDisclaimer className="mb-8 text-left" />
      <button type="button" onClick={onContinue} className={testBtnPrimary}>
        {hasNextChapter ? t('test.moveToNextChapter') : t('test.finishAbilityTest')}
      </button>
    </div>
  );
}

export default AbilityChapterComplete;
